"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPPO = [
    { deviceName: 'Oppo F1s', brandName: 'Oppo', deviceCode: 'F1s' },
    { deviceName: 'Oppo A1k', brandName: 'Oppo', deviceCode: 'CPH1923' },
    { deviceName: 'Oppo F3', brandName: 'Oppo', deviceCode: 'CPH1609' },
    { deviceName: 'Oppo F3 Plus', brandName: 'Oppo', deviceCode: 'CPH1613' },
    { deviceName: 'Oppo F5', brandName: 'Oppo', deviceCode: 'CPH1723' },
    { deviceName: 'Oppo F5 Youth', brandName: 'Oppo', deviceCode: 'CPH1725' },
    { deviceName: 'Oppo F7', brandName: 'Oppo', deviceCode: 'CPH1819' },
    { deviceName: 'Oppo F9', brandName: 'Oppo', deviceCode: 'CPH1823' },
    { deviceName: 'Oppo F9', brandName: 'Oppo', deviceCode: 'CPH1825' },
    { deviceName: 'Oppo F11', brandName: 'Oppo', deviceCode: 'CPH1911' },
    { deviceName: 'Oppo F11 Pro', brandName: 'Oppo', deviceCode: 'CPH1969' },
    { deviceName: 'Oppo A30', brandName: 'Oppo', deviceCode: 'A30' },
    { deviceName: 'Oppo A37', brandName: 'Oppo', deviceCode: 'A37' },
    { deviceName: 'Oppo A71', brandName: 'Oppo', deviceCode: 'CPH1717' },
    { deviceName: 'Oppo A71', brandName: 'Oppo', deviceCode: 'CPH1801' },
    { deviceName: 'Oppo A77', brandName: 'Oppo', deviceCode: 'CPH1715' },
    { deviceName: 'Oppo A57', brandName: 'Oppo', deviceCode: 'CPH1701' },
    { deviceName: 'Oppo A79', brandName: 'Oppo', deviceCode: 'A79' },
    { deviceName: 'Oppo A83', brandName: 'Oppo', deviceCode: 'CPH1729' },
    { deviceName: 'Oppo A83 (2018)', brandName: 'Oppo', deviceCode: 'CPH1827' },
    { deviceName: 'Oppo A3', brandName: 'Oppo', deviceCode: 'CPH1837' },
    { deviceName: 'Oppo A73T', brandName: 'Oppo', deviceCode: 'A73t' },
    { deviceName: 'Oppo A3S', brandName: 'Oppo', deviceCode: 'CPH1803' },
    { deviceName: 'Oppo A37F', brandName: 'Oppo', deviceCode: 'A37f' },
    { deviceName: 'Oppo A7', brandName: 'Oppo', deviceCode: 'CPH1901' },
    { deviceName: 'Oppo A7', brandName: 'Oppo', deviceCode: 'CPH1905' },
    { deviceName: 'Oppo A5s', brandName: 'Oppo', deviceCode: 'CPH1909' },
    { deviceName: 'Oppo A5s', brandName: 'Oppo', deviceCode: 'CPH1912' },
    { deviceName: 'Oppo A5 (2020)', brandName: 'Oppo', deviceCode: 'CPH1931' },
    { deviceName: 'Oppo A9 (2020)', brandName: 'Oppo', deviceCode: 'CPH1937' },
    { deviceName: 'Oppo Find 5', brandName: 'Oppo', deviceCode: 'X909' },
    { deviceName: 'Oppo Find 7', brandName: 'Oppo', deviceCode: 'X9076' },
    { deviceName: 'Oppo Find X', brandName: 'Oppo', deviceCode: 'CPH1871' },
    { deviceName: 'Oppo Find X', brandName: 'Oppo', deviceCode: 'PAFM00' },
    { deviceName: 'Oppo R1S', brandName: 'Oppo', deviceCode: 'R8000' },
    { deviceName: 'Oppo R3', brandName: 'Oppo', deviceCode: 'R7005' },
    { deviceName: 'Oppo R5', brandName: 'Oppo', deviceCode: 'R8106' },
    { deviceName: 'Oppo R7', brandName: 'Oppo', deviceCode: 'R7' },
    { deviceName: 'Oppo R7 Plus', brandName: 'Oppo', deviceCode: 'R7plus' },
    { deviceName: 'Oppo R9', brandName: 'Oppo', deviceCode: 'R9' },
    { deviceName: 'Oppo R9s', brandName: 'Oppo', deviceCode: 'R9s' },
    { deviceName: 'Oppo R9 Plus', brandName: 'Oppo', deviceCode: 'CPH1611' },
    { deviceName: 'Oppo R11', brandName: 'Oppo', deviceCode: 'CPH1707' },
    { deviceName: 'Oppo R11 Plus', brandName: 'Oppo', deviceCode: 'R11 Plus' },
    { deviceName: 'Oppo R11s', brandName: 'Oppo', deviceCode: 'R11s' },
    { deviceName: 'Oppo R11s Plus', brandName: 'Oppo', deviceCode: 'CPH1721' },
    { deviceName: 'Oppo R15', brandName: 'Oppo', deviceCode: 'PACT00' },
    { deviceName: 'Oppo R15', brandName: 'Oppo', deviceCode: 'PACM00' },
    { deviceName: 'Oppo R15 Pro', brandName: 'Oppo', deviceCode: 'CPH1831' },
    { deviceName: 'Oppo R17', brandName: 'Oppo', deviceCode: 'PBEM00' },
    { deviceName: 'Oppo R17 Pro', brandName: 'Oppo', deviceCode: 'PBDT00' },
    { deviceName: 'Oppo K3', brandName: 'Oppo', deviceCode: 'CPH1955' },
    { deviceName: 'Oppo K5', brandName: 'Oppo', deviceCode: 'PCNM00' },
    { deviceName: 'Oppo Reno', brandName: 'Oppo', deviceCode: 'CPH1917' },
    { deviceName: 'Oppo Reno', brandName: 'Oppo', deviceCode: 'PCAT00' },
    { deviceName: 'Oppo Reno Z', brandName: 'Oppo', deviceCode: 'CPH1979' },
    { deviceName: 'Oppo Reno2', brandName: 'Oppo', deviceCode: 'CPH1907' },
    { deviceName: 'Oppo Reno2 Z', brandName: 'Oppo', deviceCode: 'CPH1945' },
    { deviceName: 'Oppo Reno2 F', brandName: 'Oppo', deviceCode: 'CPH1989' },
    { deviceName: 'Oppo Reno Ace', brandName: 'Oppo', deviceCode: 'PCLM10' },
    { deviceName: 'Oppo Reno 10x Zoom', brandName: 'Oppo', deviceCode: 'CPH1919' },
    { deviceName: 'Oppo Reno 5G', brandName: 'Oppo', deviceCode: 'CPH1921' }
];
//# sourceMappingURL=oppo.js.map